// TODO: detect if menu items are slotted and add class to ul

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-form-header',
  styleUrl: 'form.css',
  shadow: false,
})
export class FormHeader {
  @Prop() formHeaderText: string = '';

  render() {
    return (
      <div class="form_header">
        <div class="header_text">{this.formHeaderText}</div>
      </div>
    );
  }
}
